import React from 'react';
import { Box, Link, Typography } from '@mui/material';

const sectionHeadingSx = {
  mt: 3,
  mb: 1,
  fontSize: '1.125rem',
  fontWeight: 600,
  color: 'text.primary',
};

const bodySx = { mb: 2, color: 'text.primary' };

const listSx = {
  pl: 2.25,
  mb: 2,
  color: 'text.primary',
  '& li': { mb: 0.75 },
};

export default function TietosuojaselosteContent({
  linkSx = { color: 'secondary.main' },
  showUpdatedDate = true,
}) {
  return (
    <>
      {showUpdatedDate && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Päivitetty 31.05.2024
        </Typography>
      )}

      <Typography variant="body1" sx={bodySx}>
        Tässä selosteessa kerromme, miten keräämme, käytämme, säilytämme ja suojaamme henkilötietojasi,
        kun käytät palveluitamme. Rahoituskanava.fi on sitoutunut suojaamaan yksityisyyttäsi ja
        varmistamaan, että tietojasi käsitellään turvallisesti ja lainmukaisesti.
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Selosteessa käsitellään seuraavia aiheita: millaisia tietoja keräämme ja miksi, miten käytämme
        ja jaamme tietojasi, oikeutesi henkilötietoihisi liittyen ja miten suojaamme tietosi. Pyydämme
        sinua lukemaan tämän selosteen huolellisesti. Jos sinulla on kysyttävää, ota meihin yhteyttä.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Rekisterinpitäjä
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Nimi: Pohjolan Rahoitusvertailu Oy
        <br />
        Y-tunnus: 3447957-4
        <br />
        Sähköposti:{' '}
        <Link href="mailto:info@rahoituskanava.fi" sx={linkSx}>
          info@rahoituskanava.fi
        </Link>
        <br />
        Rekisteriasioista vastaava henkilö: Tietohallinto / Pohjolan Rahoitusvertailu Oy
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Rekisterin nimi
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Rahoituskanava.fi -verkkopalvelun asiakasrekisteri
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Henkilötietojen käsittelyn tarkoitukset
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Keräämme ja käsittelemme henkilötietoja seuraaviin tarkoituksiin:
      </Typography>
      <Box component="ul" sx={listSx}>
        <li>Rahoituspalveluiden tarjoaminen yrityksille (yrityslainat, laskurahoitus)</li>
        <li>Asiakaspalvelu</li>
        <li>Palveluidemme markkinointi yrityksille</li>
        <li>Tilastointi ja analysointi palvelun parantamiseksi</li>
        <li>Rekisterin tietosisältö</li>
      </Box>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Rekisteriin kerätään ja tallennetaan seuraavia tietoja
      </Typography>
      <Box component="ul" sx={listSx}>
        <li>Yrityksen nimi</li>
        <li>Y-tunnus</li>
        <li>Yrityksen edustajan nimi</li>
        <li>Osoite</li>
        <li>Sähköposti</li>
        <li>Puhelinnumero</li>
        <li>Tietoja verkkopalvelun käytöstä</li>
        <li>Henkilötietojen lähteet</li>
      </Box>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Henkilötiedot kerätään seuraavista lähteistä
      </Typography>
      <Box component="ul" sx={listSx}>
        <li>
          Julkiset rekisterit (esim. Patentti- ja rekisterihallitus, Yhteisötietojärjestelmä)
        </li>
        <li>Suoraan yrityksiltä ja niiden edustajilta verkkopalvelumme kautta</li>
      </Box>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Henkilötietojen säilytysaika
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Säilytämme henkilötietoja viiden vuoden ajan, ellei ole syytä poistaa tietoja aikaisemmin.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Henkilötietojen luovutukset
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Luovutamme henkilötietoja kolmansille osapuolille seuraavissa tapauksissa:
      </Typography>
      <Box component="ul" sx={listSx}>
        <li>Yhteistyökumppanit, kuten pankit ja rahoitusyhtiöt, palveluiden tarjoamiseksi</li>
        <li>Alihankkijat, jotka tukevat palveluidemme toimintaa</li>
      </Box>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Henkilötietojen siirto EU- tai ETA-alueen ulkopuolelle
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Henkilötietoja ei siirretä EU- tai ETA-alueen ulkopuolelle.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Rekisteröidyn oikeudet
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Yrityksillä ja yritysten edustajilla on seuraavat oikeudet:
      </Typography>
      <Box component="ul" sx={listSx}>
        <li>
          Oikeus tarkastaa tiedot: Rekisteröity voi tarkastaa, mitä tietoja hänestä on tallennettu.
        </li>
        <li>
          Oikeus tietojen oikaisemiseen: Rekisteröidyllä on oikeus vaatia virheellisten tai
          vanhentuneiden tietojen oikaisemista.
        </li>
        <li>
          Oikeus vastustaa käsittelyä: Rekisteröidyllä on oikeus vastustaa henkilötietojen käsittelyä,
          mikäli he kokevat, että tietoja käsitellään lainvastaisesti.
        </li>
        <li>
          Oikeus tietojen poistamiseen: Rekisteröidyllä on oikeus vaatia tietojen poistamista
          rekisteristä, mikäli käsittelylle ei ole enää perustetta.
        </li>
      </Box>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Valitusoikeus
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Rekisteröidyllä on oikeus tehdä valitus valvontaviranomaiselle, jos hän katsoo, että
        henkilötietojen käsittelyssä rikotaan tietosuojasäännöksiä.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Tietosuojan toteuttaminen
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Olemme toteuttaneet asianmukaiset tekniset ja organisatoriset toimenpiteet henkilötietojen
        suojaamiseksi. Näihin toimenpiteisiin kuuluvat mm. palomuurit, salausmenetelmät ja turvalliset
        tietoverkot.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Yhteystiedot
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Mikäli sinulla on kysyttävää tästä tietosuojaselosteesta tai haluat käyttää rekisteröidyn
        oikeuksiasi, voit ottaa meihin yhteyttä sähköpostitse osoitteeseen{' '}
        <Link href="mailto:info@rahoituskanava.fi" sx={linkSx}>
          info@rahoituskanava.fi
        </Link>
        .
      </Typography>
    </>
  );
}
